package cc.bluepeak.clubmanager.site.pages

import androidx.compose.runtime.Composable
import cc.bluepeak.clubmanager.site.Res
import cc.bluepeak.clubmanager.site.components.layouts.PageLayoutData
import cc.bluepeak.clubmanager.site.components.widgets.Checkmark
import cc.bluepeak.clubmanager.site.components.widgets.FieldTag
import cc.bluepeak.clubmanager.site.components.widgets.LineTag
import cc.bluepeak.clubmanager.site.components.widgets.LiveDemo
import cc.bluepeak.clubmanager.site.styles.ButtonLinkVariant
import cc.bluepeak.clubmanager.site.styles.PaddedCardStyle
import cc.bluepeak.clubmanager.site.styles.SecondaryParagraph
import cc.bluepeak.clubmanager.site.styles.Theme
import com.varabyte.kobweb.compose.css.BackgroundPosition
import com.varabyte.kobweb.compose.css.BackgroundSize
import com.varabyte.kobweb.compose.css.CSSPosition
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.lucide.LucideCalendarSync
import com.varabyte.kobweb.silk.components.icons.lucide.LucideCalendars
import com.varabyte.kobweb.silk.components.icons.lucide.LucideUserRoundArrowLeft
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text


@InitRoute
fun initCalendar(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(Res.string.calendar_tag, Res.string.calendar_title))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun Calendar() {
    Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(2.cssRem)) {
        Column(PaddedCardStyle.toModifier().fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {
            FieldTag(Res.string.calendar_tag)
            H1(
                Modifier.textAlign(TextAlign.Center).toAttrs()
            ) { Text(Res.string.calendar_title) }
            Image(Res.image.calendar_icon, Modifier.height(140.px))
            P(
                SecondaryParagraph.toModifier().margin(top = 1.cssRem, bottom = 2.cssRem).textAlign(TextAlign.Center)
                    .toAttrs()
            ) {
                Text(Res.string.calendar_desc)
            }
            Row(Modifier.flexWrap(FlexWrap.Wrap), horizontalArrangement = Arrangement.spacedBy(1.cssRem)) {
                Checkmark(Res.string.calendar_check_events)
                Checkmark(Res.string.calendar_check_access)
                Checkmark(Res.string.calendar_check_shared)
            }
        }
        LiveDemo("calendar", Res.string.calendar_demo_cta, Res.string.calendar_demo_hint)
        Column(PaddedCardStyle.toModifier().fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(4.cssRem)) {
            SimpleGrid(numColumns(1, md = 2), Modifier.gap(1.cssRem).fillMaxWidth()) {
                Column {
                    FieldTag(Res.string.calendar_club_tag)
                    H1 {
                        Text(Res.string.calendar_club_title)
                    }
                    P(
                        SecondaryParagraph.toModifier().margin(top = 1.cssRem, bottom = 2.cssRem)
                            .maxWidth(500.px).toAttrs()
                    ) {
                        Text(Res.string.calendar_club_desc)
                    }
                    Column(verticalArrangement = Arrangement.spacedBy(.5.cssRem)) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(.5.cssRem)
                        ) {
                            LucideCalendarSync(color = Theme.primary, size = 1.5.em)
                            SpanText(Res.string.calendar_club_check_snyc)
                        }
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(.5.cssRem)
                        ) {
                            LucideCalendars(color = Theme.primary, size = 1.5.em)
                            SpanText(Res.string.calendar_club_check_types)
                        }
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(.5.cssRem)
                        ) {
                            LucideUserRoundArrowLeft(color = Theme.primary, size = 1.5.em)
                            SpanText(Res.string.calendar_club_check_teams)
                        }
                    }
                }
                Image(
                    Res.image.team_training, Modifier.borderRadius(Theme.shapes.medium)
                        .fillMaxWidth()
                        .maxHeight(360.px)
                        .objectFit(ObjectFit.Cover)
                )
            }
            SimpleGrid(numColumns(1, md = 2), Modifier.gap(1.cssRem).fillMaxWidth()) {
                Image(
                    Res.image.notes_icon, Modifier.displayIfAtLeast(Breakpoint.MD)
                        .fillMaxWidth()
                        .maxHeight(280.px)
                        .objectFit(ObjectFit.Contain)
                )

                Column {
                    FieldTag(Res.string.calendar_team_tag)
                    H1 {
                        Text(Res.string.calendar_team_title)
                    }
                    P(
                        SecondaryParagraph.toModifier().margin(top = 1.cssRem, bottom = 2.cssRem)
                            .maxWidth(500.px).toAttrs()
                    ) {
                        Text(Res.string.calendar_team_desc)
                    }
                    Link(Res.link.squadManagement, Res.string.calendar_team_cta, variant = ButtonLinkVariant)
                }
            }
        }
        SimpleGrid(
            numColumns(1, 2), PaddedCardStyle.toModifier().fillMaxWidth()
                .gap(1.cssRem)
                .backgroundImage(url("""/${Res.string.locale}/${Res.image.fabric3}"""))
                .background {
                    size(BackgroundSize.Cover)
                    position(BackgroundPosition.of(CSSPosition.Center))
                }) {
            Column {
                LineTag(Res.string.calendar_cta_tag, Modifier.color(Theme.white))
                H1(Modifier.color(Theme.white).toAttrs()) {
                    Text(Res.string.calendar_cta_title)
                }
            }
            Column(PaddedCardStyle.toModifier()) {
                P(Modifier.margin(bottom = 1.cssRem).toAttrs()) {
                    Text(Res.string.calendar_cta_desc)
                }
                Link(Res.link.register, Res.string.calendar_cta_cta, variant = ButtonLinkVariant)
            }
        }
    }
}